import type { AnalyticsPageViewKey } from '@bo-types/analytics';
import { getPageViewName } from '@bo-utils/analytics';
import { useAnalytics } from '@bo-hooks/analytics';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export interface AnalyticsPageViewsProps {
  pageViewKey: AnalyticsPageViewKey;
}

export const useAnalyticsPageViews = ({
  pageViewKey
}: AnalyticsPageViewsProps) => {
  const { pathname } = useLocation();
  const { isAnalyticsDisabled, page } = useAnalytics();

  // Call Rudderstack page event on every location change
  useEffect(() => {
    if (isAnalyticsDisabled) {
      return;
    }

    const pageName = getPageViewName(pageViewKey, pathname);

    if (pageName) {
      page(pageName);
    }
  }, [isAnalyticsDisabled, page, pageViewKey, pathname]);
};
